import React from "react"
import FormInvestorPayment from "./Form"
import ManageInvestorPayment from "./ManageItem"

export default function UpdateInvestorPayment({ params }) {

  return <ManageInvestorPayment
    params={ params }
    callback={ data => <FormInvestorPayment investorPayment={ data } /> }
  />
}



// WEBPACK FOOTER //
// ./src/components/Financiers/Investors/Payments/Update.js